import { ColumnDefinition } from '../types/column.types'
import { ExcelColumn } from '../../hooks/useExportToExcel'

// cellRendererType is not read here, so grid-table's GridColumn (which redefines it) fits too.
const columnsToExcel = <T,>(
  columns: Omit<ColumnDefinition<T>, 'cellRendererType'>[]
): ExcelColumn<T>[] =>
  columns
    .filter((col) => col.visible !== false)
    .map((col) => ({
      header: col.title,
      accessor: (row: T): string | number => {
        const raw = row[col.key]
        if (col.labelResolver) return col.labelResolver(raw)
        if (col.formatValue) return col.formatValue(raw as T[keyof T])
        if (typeof raw === 'boolean') return raw ? 'כן' : 'לא'
        return raw == null ? '' : String(raw)
      },
    }))

export default columnsToExcel
